module.exports = __webpack_public_path__ + "assets/img/page4-nav-item-10-55f483f3.png";